import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Startpagina ${ctx.brand} anonieme chat`,
    languageButtonLabel: `Taal`,
    languageModalTitle: `Kies een taal`,
    languageModalCloseLabel: `Sluit taalmenu`,
  },
  languageOptions: {
    'en-US': {
      label: `Engels (Verenigde Staten)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Engels (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Engels (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Engels (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugees (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugees (Brazilië)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Duits (Duitsland)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Duits (Oostenrijk)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Duits (Zwitserland)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spaans (Spanje)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Frans (Frankrijk)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiaans (Italië)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederlands (Nederland)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Pools (Polen)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Zweeds (Zweden)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Deens (Denemarken)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Fins (Finland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Noors (Noorwegen)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `IJslands (IJsland)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japans (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreaans (Zuid-Korea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Chinees (China)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonees (Hongkong SAR van China)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamees (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesisch (Indonesië)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengaals (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Perzisch (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigeriaans Pidgin (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russisch (Rusland)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabisch (Saoedi-Arabië)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabisch (Verenigde Arabische Emiraten)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabisch (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokkaans Arabisch (Marokko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turks (Turkije)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Kies een taal`,
    closeLabel: `Sluit taalmenu`,
  },
  languageHint: (ctx) => `Switch tussen ${ctx.localesCount}+ talen zonder ooit een account aan te maken.`,
  readPagePrompt: ({languageLabel}) => `Lees deze pagina in ${languageLabel}.`,
};
